(() => {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const compactVariantQuery = window.matchMedia('(max-width: 767px)');
  const panelClasses = [
    'nimall-product-panel-1',
    'nimall-product-panel-2',
    'nimall-product-panel-3',
    'nimall-product-panel-4'
  ];

  const tagProductPanels = () => {
    document.querySelectorAll('#MainContent .halo-product-block').forEach((block, index) => {
      const targetClass = panelClasses[index % panelClasses.length];
      if (!block.classList.contains(targetClass)) {
        block.classList.remove(...panelClasses);
        block.classList.add(targetClass);
      }
    });
  };

  // Layered, concrete illustrations; scoped sizing protects them from theme SVG defaults.
  const serviceIllustrations = {
    truck: '<rect x="5" y="17" width="33" height="28" rx="4" fill="#FFE1AE"/><path d="M38 27h10l10 12v6H38Z" fill="#F5AD43"/><path d="M43 30h4l6 8H43Z" fill="#FFFDF7"/><path d="M5 45h53M38 23v22M13 25h16M13 31h10"/><circle cx="17" cy="47" r="6" fill="#FFFFFF"/><circle cx="48" cy="47" r="6" fill="#FFFFFF"/><circle cx="17" cy="47" r="2" fill="#9A5A17" stroke="none"/><circle cx="48" cy="47" r="2" fill="#9A5A17" stroke="none"/>',
    parcel: '<path d="m9 23 21-11 21 11v25L30 59 9 48Z" fill="#D7EFE2"/><path d="m9 23 21 11 21-11M30 34v25M20 17l21 11v10"/><path d="m41 28 6-3v9l-6 4Z" fill="#FFFFFF"/><circle cx="48" cy="16" r="12" fill="#FFFFFF"/><path d="M48 9v7l5 3"/>',
    returns: '<path d="m12 28 19-9 19 9v22l-19 9-19-9Z" fill="#D7EFE2"/><path d="m12 28 19 9 19-9M31 37v22M22 24l18 9"/><path d="M49 18A20 20 0 0 0 14 13M14 5v9h9" stroke-width="3"/><path d="M21 44h6"/>',
    payment: '<rect x="5" y="14" width="47" height="33" rx="5" fill="#D7EFE2"/><path d="M6 24h45" stroke-width="6"/><rect x="12" y="32" width="10" height="7" rx="1.5" fill="#F6D899"/><path d="M28 36h8"/><path d="m47 31 12 5v9c0 8-12 14-12 14s-12-6-12-14v-9Z" fill="#FFFFFF"/><path d="m41 44 4 4 8-9" stroke-width="3"/>'
  };
  const productServiceIcon = (kind) => `
    <svg aria-hidden="true" focusable="false" viewBox="0 0 64 64" width="52" height="52" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
      ${serviceIllustrations[kind]}
    </svg>`;

  const injectProductCommercePanel = () => {
    if (!document.body.classList.contains('template-product')) return;

    const productTop = document.querySelector('#MainContent .productView-top');
    const productDetails = productTop?.querySelector('.productView-details');
    if (!productTop || !productDetails || productTop.querySelector('.nimall-commerce-aside')) return;

    const legacyLabels = new Set([
      'shipping information',
      'returns & refunds',
      'delivery estimates at checkout'
    ]);

    productDetails.querySelectorAll('.productView-moreItem').forEach((item) => {
      const heading = item.querySelector('h1, h2, h3, .title');
      if (heading && legacyLabels.has(heading.textContent.trim().toLowerCase())) {
        item.classList.add('nimall-legacy-service-item');
      }
    });

    const aside = document.createElement('aside');
    aside.className = 'nimall-commerce-aside';
    const ar = document.documentElement.lang.startsWith('ar');
    const ui = {"Seller, delivery and payment information":"معلومات البائع والتوصيل والدفع","Marketplace seller":"بائع السوق","Sold by Nimall":"يباع بواسطة Nimall","Official marketplace retail":"متجر Nimall الرسمي","Order services":"خدمات الطلب","Shipping & fulfilment":"الشحن وتنفيذ الطلب","Origin and route depend on item and destination":"يختلف مصدر الشحن ومساره حسب المنتج والوجهة","DETAILS":"التفاصيل","Fulfilment":"تنفيذ الطلب","Delivery at checkout":"التوصيل عند الدفع","Availability, fee and ETA are confirmed before payment":"يتم تأكيد التوفر والرسوم والموعد المتوقع قبل الدفع","Easy returns":"إرجاع بسهولة","Eligible items follow the Nimall return policy":"تخضع المنتجات المؤهلة لسياسة إرجاع Nimall","Secure payments":"مدفوعات آمنة","Cards, Tabby, Tamara and COD where available":"البطاقات وTabby وTamara والدفع عند الاستلام عند توفرها","Seller":"البائع","Delivery":"التوصيل","Returns":"الإرجاع","Payment":"الدفع","More details":"المزيد من التفاصيل"};
    const tr = text => ar ? (ui[text] || text) : text;
    aside.setAttribute('aria-label', tr('Seller, delivery and payment information'));
    const storefrontRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const shippingUrl = `${storefrontRoot}blogs/news/shipping-info`;
    aside.innerHTML = `
      <section class="nimall-seller-card">
        <div class="nimall-seller-card__label">${tr("Marketplace seller")}</div>
        <div class="nimall-seller-card__identity">
          <a class="nimall-seller-card__mark" href="https://nimall.com/" aria-label="Nimall homepage">Nimall<span class="nimall-seller-card__dot" aria-hidden="true">.</span></a>
          <div>
            <strong>${tr("Sold by Nimall")}</strong>
            <span>${tr("Official marketplace retail")}</span>
          </div>
        </div>
      </section>

      <section class="nimall-service-stack" aria-label="${tr("Order services")}">
        <a class="nimall-service-card nimall-service-card--flyeagle" href="${shippingUrl}">
          <span class="nimall-service-card__icon">${productServiceIcon('truck')}</span>
          <span class="nimall-service-card__copy"><strong>${tr("Shipping & fulfilment")}</strong><small>${tr("Origin and route depend on item and destination")}</small><span class="nimall-service-card__badge">${tr("DETAILS")}</span></span>
          <span class="nimall-service-card__arrow" aria-hidden="true">›</span>
        </a>

        <a class="nimall-service-card" href="${shippingUrl}">
          <span class="nimall-service-card__icon">${productServiceIcon('parcel')}</span>
          <span class="nimall-service-card__copy"><strong>${tr("Delivery at checkout")}</strong><small>${tr("Availability, fee and ETA are confirmed before payment")}</small></span>
          <span class="nimall-service-card__arrow" aria-hidden="true">›</span>
        </a>

        <a class="nimall-service-card" href="${storefrontRoot}blogs/news/refund-policy">
          <span class="nimall-service-card__icon">${productServiceIcon('returns')}</span>
          <span class="nimall-service-card__copy"><strong>${tr("Easy returns")}</strong><small>${tr("Eligible items follow the Nimall return policy")}</small></span>
          <span class="nimall-service-card__arrow" aria-hidden="true">›</span>
        </a>

        <a class="nimall-service-card" href="${storefrontRoot}blogs/payment/payment-policy">
          <span class="nimall-service-card__icon">${productServiceIcon('payment')}</span>
          <span class="nimall-service-card__copy"><strong>${tr("Secure payments")}</strong><small>${tr("Cards, Tabby, Tamara and COD where available")}</small></span>
          <span class="nimall-service-card__arrow" aria-hidden="true">›</span>
        </a>
      </section>`;

    const seller = aside.querySelector('.nimall-seller-card');
    const services = [...aside.querySelectorAll('.nimall-service-card')];
    const mobileTiles = document.createElement('section');
    mobileTiles.className = 'nimall-mobile-service-tiles';
    mobileTiles.setAttribute('aria-label', tr('Seller, delivery and payment information'));
    const items = [
      { label: tr('Seller'), source: seller, seller: true },
      { label: tr('Fulfilment'), source: services[0] },
      { label: tr('Delivery'), source: services[1] },
      { label: tr('Returns'), source: services[2] },
      { label: tr('Payment'), source: services[3] }
    ];
    const details = [];
    items.forEach((item, index) => {
      if (!item.source) return;
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'nimall-mobile-service-tile';
      tile.setAttribute('aria-expanded', 'false');
      tile.setAttribute('aria-controls', `nimall-mobile-service-detail-${index}`);
      const icon = document.createElement('span');
      icon.className = 'nimall-mobile-service-tile__icon';
      if (item.seller) {
        icon.classList.add('nimall-mobile-service-tile__icon--seller');
        icon.textContent = 'Nimall';
        const dot = document.createElement('span');
        dot.className = 'nimall-seller-card__dot';
        dot.textContent = '.';
        icon.appendChild(dot);
      } else {
        const illustration = item.source.querySelector('.nimall-service-card__icon svg');
        if (illustration) icon.appendChild(illustration.cloneNode(true));
      }
      const label = document.createElement('span');
      label.className = 'nimall-mobile-service-tile__label';
      label.textContent = item.label;
      tile.append(icon, label);
      mobileTiles.appendChild(tile);

      const detail = document.createElement('div');
      detail.id = `nimall-mobile-service-detail-${index}`;
      detail.className = 'nimall-mobile-service-detail';
      detail.hidden = true;
      if (item.seller) {
        const identity = item.source.querySelector('.nimall-seller-card__identity');
        if (identity) detail.appendChild(identity.cloneNode(true));
      } else {
        const copy = item.source.querySelector('.nimall-service-card__copy');
        if (copy) detail.appendChild(copy.cloneNode(true));
        const link = document.createElement('a');
        link.className = 'nimall-mobile-service-detail__link';
        link.href = item.source.href;
        link.textContent = tr('More details');
        detail.appendChild(link);
      }
      details.push(detail);
      tile.addEventListener('click', () => {
        const open = tile.getAttribute('aria-expanded') === 'true';
        mobileTiles.querySelectorAll('.nimall-mobile-service-tile').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        details.forEach((panel) => { panel.hidden = true; });
        if (!open) {
          tile.setAttribute('aria-expanded', 'true');
          detail.hidden = false;
        }
      });
    });
    mobileTiles.append(...details);
    aside.appendChild(mobileTiles);

    productTop.appendChild(aside);
    productTop.classList.add('nimall-product-commerce-layout');
  };

  const placePdpRecommendations = () => {
    if (!document.body.classList.contains('template-product')) return;

    const productTop = document.querySelector('#MainContent .productView-top');
    const gallery = productTop?.querySelector('.productView-images');
    const related = document.querySelector('#MainContent [data-recommendations-block]');
    const relatedSection = related?.closest('.shopify-section') || related?.parentElement;
    const relatedGrid = related?.querySelector('.products-grid');
    const primaryTemplate = document.querySelector('#nimall-pdp-primary-card');
    if (!productTop || !gallery || !relatedSection || !relatedGrid || !primaryTemplate) return;

    const cards = [...relatedGrid.children].filter((node) => node.classList.contains('product'));
    if (!cards.length) {
      relatedSection.hidden = true;
      return;
    }
    // Related results are discovery, never evidence of a complementary pair.
    // Collection fallback is too broad for the PDP recommendation rail.
    const isFallback = (node) => Boolean(node.querySelector('a[href*="pr_prod_strat=collection_fallback"]'));
    const productHandle = decodeURIComponent(window.location.pathname.match(/\/products\/([^/?]+)/)?.[1] || '');
    const noVerifiedCandidates = new Set([
      'dog-pee-pads-20pcs-60x90cm-absorbent-disposable-training-pads',
      'applicable-to-iphoneduo-folding-screen-mobile-phone-case-matte-skin-magnetic-suction-apple-18duo-folding-protective-case-central-shaft'
    ]);
    const watchAlternatives = new Set([
      '1-81-inch-smart-watch-for-men-and-women',
      'smart-watch-with-1-39-full-touch-screen-smartwatch-and-100-exercise-sports-modes'
    ]);
    const eligible = cards.filter((node) => {
      if (isFallback(node) || noVerifiedCandidates.has(productHandle)) return false;
      if (productHandle !== '1-38-inch-smart-watch') return true;
      try {
        const card = node.querySelector('.product-item[data-json-product]');
        return watchAlternatives.has(JSON.parse(card?.getAttribute('data-json-product') || '{}').handle);
      } catch (_) { return false; }
    });
    cards.filter((node) => !eligible.includes(node)).forEach((node) => node.remove());
    if (!eligible.length) {
      relatedSection.hidden = true;
      relatedSection.dataset.nimallMissingReason =
        noVerifiedCandidates.has(productHandle) ? 'compatibility_unverified' :
        cards.length ? 'unqualified_recommendations' : 'no_candidates_or_request_pending';
      return;
    }
    relatedSection.hidden = false;
    relatedSection.classList.add('nimall-pdp-also-viewed');
    const title = relatedSection.querySelector('.halo-block-header .title .text');
    const ar = document.documentElement.lang.startsWith('ar');
    if (title) title.textContent = productHandle === '1-38-inch-smart-watch'
      ? (ar ? 'منتجات مشابهة' : 'Similar products')
      : (ar ? 'اكتشف المزيد' : 'More to explore');
    if (relatedSection.previousElementSibling !== productTop) productTop.after(relatedSection);
  };
  const setCarouselColumns = (carousel) => {
    if (carousel.closest('.nimall-pdp-bundle, .nimall-pdp-also-viewed')) return;
    if (!window.jQuery || typeof window.jQuery(carousel).slick !== 'function') return;

    const slider = window.jQuery(carousel);
    let currentSlides;
    let currentScroll;

    try {
      currentSlides = Number(slider.slick('slickGetOption', 'slidesToShow')) || 1;
      currentScroll = Number(slider.slick('slickGetOption', 'slidesToScroll')) || 1;
    } catch (error) {
      return;
    }

    if (!carousel.dataset.nimallOriginalSlidesToShow) {
      carousel.dataset.nimallOriginalSlidesToShow = String(currentSlides);
      carousel.dataset.nimallOriginalSlidesToScroll = String(currentScroll);
    }

    const targetSlides = desktopQuery.matches
      ? 7
      : Number(carousel.dataset.nimallOriginalSlidesToShow) || currentSlides;
    const targetScroll = desktopQuery.matches
      ? 7
      : Number(carousel.dataset.nimallOriginalSlidesToScroll) || currentScroll;

    if (currentSlides === targetSlides && currentScroll === targetScroll) return;

    slider.slick('slickSetOption', 'slidesToShow', targetSlides, false);
    slider.slick('slickSetOption', 'slidesToScroll', targetScroll, true);
  };

  const compactProductVariantControls = () => {
    if (!document.body.classList.contains('template-product')) return;
    const product = document.querySelector('#MainContent .productView-product');
    const reviewRow = product?.querySelector('.y15-pdp-review-row');
    const actions = product?.querySelector('.y15-pdp-secondary-actions');
    const variants = product?.querySelector('.productView-variants');
    if (!product) return;

    if (!compactVariantQuery.matches) {
      product.classList.remove('nimall-pdp-variants-compact');
      if (actions?.parentElement === variants) {
        if (reviewRow) reviewRow.appendChild(actions);
        else if (!actions.children.length) actions.remove();
      }
      return;
    }
    if (!reviewRow || !actions || !variants?.querySelector('.product-form__input')) return;

    if (actions.parentElement !== variants) variants.prepend(actions);
    product.classList.add('nimall-pdp-variants-compact');
  };

  const labelProductColorSwatches = () => {
    if (!document.body.classList.contains('template-product')) return;
    document.querySelectorAll('#MainContent .productView-variants .product-form__swatch').forEach((fieldset) => {
      fieldset.querySelectorAll('input.product-form__radio').forEach((input) => {
        const label = input.nextElementSibling;
        if (!label?.matches('label.product-form__label') || label.querySelector('.nimall-variant-swatch-name')) return;
        const name = document.createElement('span');
        name.className = 'nimall-variant-swatch-name';
        name.textContent = input.value;
        label.appendChild(name);
      });
    });
  };

  const applyProductFeed = () => {
    tagProductPanels();
    injectProductCommercePanel();
    labelProductColorSwatches();
    compactProductVariantControls();
    placePdpRecommendations();
    document
      .querySelectorAll(
        '#MainContent .products-grid.slick-initialized, #MainContent .products-carousel.slick-initialized'
      )
      .forEach(setCarouselColumns);
  };

  let scheduled = false;
  const scheduleProductFeed = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyProductFeed();
    });
  };

  // Ignore unrelated review, tracking, countdown and cart mutations. Only new
  // product surfaces need a feed pass; observe carousel initialization separately.
  const relevantSurface = '.halo-product-block, .productView-top, .productView-variants, .y15-pdp-secondary-actions, .products-grid, .products-carousel, .product-item[data-json-product]';
  const observer = new MutationObserver((records) => {
    if (records.some((record) => {
      if (record.type === 'attributes') {
        return record.target.matches('.products-grid.slick-initialized, .products-carousel.slick-initialized') &&
          !(record.oldValue || '').split(/\s+/).includes('slick-initialized');
      }
      return [...record.addedNodes].some((node) => node.nodeType === 1 &&
        (node.matches(relevantSurface) || node.querySelector(relevantSurface)));
    })) scheduleProductFeed();
  });
  const observeProductSurfaces = () => {
    const main = document.getElementById('MainContent');
    if (main) observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    scheduleProductFeed();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeProductSurfaces, { once: true });
  else observeProductSurfaces();
  window.addEventListener('load', scheduleProductFeed, { once: true });
  desktopQuery.addEventListener?.('change', scheduleProductFeed);
  compactVariantQuery.addEventListener?.('change', scheduleProductFeed);
  window.addEventListener('resize', scheduleProductFeed, { passive: true });
  let observedViewportWidth = document.documentElement.clientWidth;
  new ResizeObserver(() => {
    const viewportWidth = document.documentElement.clientWidth;
    if (viewportWidth !== observedViewportWidth) {
      observedViewportWidth = viewportWidth;
      scheduleProductFeed();
    }
  }).observe(document.documentElement);
  window.setTimeout(scheduleProductFeed, 600);
  window.setTimeout(scheduleProductFeed, 1800);
})();
